import { render, staticRenderFns } from "./JobOpeningDetails.vue?vue&type=template&id=4e9fbe27&scoped=true"
import script from "./JobOpeningDetails.vue?vue&type=script&lang=js"
export * from "./JobOpeningDetails.vue?vue&type=script&lang=js"
import style0 from "./JobOpeningDetails.vue?vue&type=style&index=0&id=4e9fbe27&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e9fbe27",
  null
  
)

export default component.exports